/**
 * Global stagger timing for `stagger-in` entrances across pages.
 * Adjust {@link STAGGER_STEP_MS} to scale all step-based delays together.
 *
 * Entrance duration / easing for `.stagger-in` are `--stagger-duration` and
 * `--stagger-easing` in `src/index.css`.
 */
export const STAGGER_STEP_MS = 10;

/** CSS `animation-delay` from a step index (0 = no delay). */
export function staggerDelay(step: number): `${number}ms` {
  return `${step * STAGGER_STEP_MS}ms`;
}

/** Delay in milliseconds (for composed values, e.g. cards). */
export function staggerMs(step: number): number {
  return step * STAGGER_STEP_MS;
}

/**
 * Delay for grid cards: first item at `firstStep`, then one step per index.
 * Default matches the previous 160ms + index * 80ms pattern.
 */
export function staggerCardDelay(index: number, firstStep = 2): number {
  return staggerMs(firstStep + index);
}

/** Step index after typical detail-page blocks (e.g. store links). */
export const STAGGER_AFTER_DETAIL_BLOCKS_STEP = 5;
